export default {
  'rg.report.availableToPayout': '可用打款',

  'rg.report.totalDeferredSales': '全部延期销售额',
  'rg.report.totalRestgroupCharges': '全部餐厅收费',
  'rg.report.totalRestgroupOtherCharges': '餐厅组其他收费',
  'rg.report.feeAndAdjustment': '费 & 调整费',
  'rg.report.availableToPayoutAmount': '可用打款金额',
  'rg.report.sales.error': '销售报表查询错误',
  'rg.report.payout.error': '可打款统计查询错误',
  'rg.report.invoice': '收款',
  'rg.report.totalDebt': '总欠款',
  'rg.report.filter.restaurant': '按餐厅筛选，可多选',
  'rg.report.date.tip': '销售报表和可用打款只能按天查找',

  'rg.accountSettiing.name': '餐厅组名称',

  'rg.report.empty.restaurants': '当前餐厅组下没有可以访问的餐厅数据',
  'rg.report.section.restaurantSales': '餐厅报表',

  'rg.action.noMenu': '没有可以访问的菜单，请联系管理员开通菜单权限',
  'rg.action.actionEmpty': '您无法访问当前页面的内容，请联系管理员开通权限',

  'report.column.comps_value': '补偿',
};
